import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="border rounded-4 bg-white shadow-sm p-4 p-md-5 text-center">
            <p className="text-uppercase text-secondary small mb-2">404 Error</p>
            <h1 className="h3 mb-3">Page not found</h1>
            <p className="text-secondary mb-4">
              เส้นทางนี้ยังไม่มีหน้าใช้งานหรืออาจถูกย้ายตำแหน่งแล้ว
            </p>
            <Link to="/" className="btn btn-dark">
              กลับหน้าแรก
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
